import { render, staticRenderFns } from "./admineditor.vue?vue&type=template&id=438d175a&scoped=true&"
import script from "./admineditor.vue?vue&type=script&lang=js&"
export * from "./admineditor.vue?vue&type=script&lang=js&"
import style0 from "./admineditor.vue?vue&type=style&index=0&id=438d175a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438d175a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('438d175a')) {
      api.createRecord('438d175a', component.options)
    } else {
      api.reload('438d175a', component.options)
    }
    module.hot.accept("./admineditor.vue?vue&type=template&id=438d175a&scoped=true&", function () {
      api.rerender('438d175a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/action/tabs/resolution/table/admineditor.vue"
export default component.exports